import React, { ReactNode, useContext, useCallback } from 'react'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import c from 'classnames'

import iconBack from '@/assets/icons/icon-back.svg'
import { BreadcrumbContext } from './BreadcrumbContext'
import styles from './index.module.less'

export interface IBreadcrumbProps {
  title?: string | ReactNode
  onBack?: FnType
  className?: string
}

const Breadcrumb: React.FC<IBreadcrumbProps> = (prop) => {
  const { title, onBack, className } = prop
  const routePath = useContext(BreadcrumbContext)
  const { id } = useParams<{ id?: string; orderNo?: string }>()
  const { t } = useTranslation()
  const route = routePath[routePath.length - 1]?.route
  const backHandler = useCallback(() => {
    if (onBack) {
      onBack()
    } else {
      history.back()
    }
  }, [onBack])

  return (
    <div className={c(className, styles.box)}>
      <div className={styles.backBtn} onClick={backHandler}>
        <img src={iconBack} />
      </div>
      {
        <div className={styles.content} key={route?.path}>
          <div className={styles.title}>{title || id || t(route?.menuTitle)}</div>
        </div>
      }
    </div>
  )
}
export default Breadcrumb
